/**
 * The sidebar.
 *
 * Labels are i18n keys — side-bar.vue renders them through $t(). Added to
 * en / ms / zh, which is what this market reads; the template's ar / es / fr
 * carry the English string rather than a machine translation, because a wrong
 * word in a language nobody here can check is worse than an English one.
 *
 * No `permission:` on the bot entries, deliberately: who may edit a brand's
 * knowledge base is already answered by which tenant the agent belongs to.
 * The admin group below DOES carry them -- see the note on that group.
 */
export const menuItems = [
    {
        id: 1,
        label: 'module.inbox',
        icon: 'mdi mdi-inbox-arrow-down',
        link: '/inbox',
    },
    // One item, so no submenu: a parent that expands to reveal a single child
    // is a click that buys nothing.
    {
        id: 10,
        label: 'module.knowledgeBase',
        icon: 'mdi mdi-robot',
        link: '/knowledge-base',
    },
    // Content the brand keeps editing, like the FAQ -- so it sits next to it,
    // not inside the brand's settings page (owner, 2026-11-02).
    {
        id: 11,
        label: 'module.gameTips',
        icon: 'mdi mdi-gamepad-variant-outline',
        link: '/game-tips',
        feature: 'game_tips',
    },
    // Hidden unless Configuration says the schedule is kept here — see the
    // appointment_host_at note in AppointmentController.
    {
        id: 20,
        label: 'module.appointment',
        icon: 'mdi mdi-calendar-check-outline',
        link: '/appointments',
        feature: 'appointments',
    },
    {
        id: 90,
        label: 'module.team',
        icon: 'mdi mdi-account-group',
        link: '/team',
    },

    /*
     * Administration.
     *
     * `permission:` here hides the entry; it is NOT the control -- the API
     * refuses the call regardless, and side-bar.vue reads the same cached
     * permission list the router does. The strings must match
     * PermissionAndRoleSeeder exactly, or the entry is invisible to everyone.
     *
     * Organisations are our CLIENTS' brands — not our own company, which this
     * app deliberately does not model.
     */
    {
        id: 100,
        label: 'module.admin',
        icon: 'mdi mdi-cog-outline',
        subItems: [
            { id: 101, label: 'module.user', link: '/users', permission: 'Read User' },
            { id: 102, label: 'module.role', link: '/roles', permission: 'Read Role' },
            { id: 103, label: 'module.organization', link: '/organizations', permission: 'Read Organisation' },
            { id: 104, label: 'module.proposal', link: '/proposals', permission: 'Read Organisation', feature: 'proposal' },
            { id: 105, label: 'module.configuration', link: '/configurations', permission: 'Read Configuration' },
            // The words one industry's customers use. Shared by every brand in
            // it, so it sits here rather than on any one brand's page.
            { id: 106, label: 'module.tonePack', link: '/industry-packs', permission: 'Read Organisation' },
            { id: 107, label: 'module.auditLog', link: '/audit-log', permission: 'Read Audit Log' },
        ],
    },
]
